import type { ComplianceViolationAggregateInput, ComplianceViolationAggregateSuccess } from '@terros/common'
import type { GetHookResponse } from '../../hooks'
import { useTantalimQuery } from '../../query'

export function useComplianceViolationAggregate(): GetHookResponse<ComplianceViolationAggregateSuccess['stats']> {
  return useTantalimQuery<
    ComplianceViolationAggregateInput,
    ComplianceViolationAggregateSuccess,
    ComplianceViolationAggregateSuccess['stats']
  >({
    url: '/compliance/violation/aggregate',
    input: {},
    queryKey: ['compliance-violation-aggregate'],
    convertResponse: (data) => data.stats,
  })
}
